import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { cwtOrderEntry } from 'src/app/models/kn-br-products.model';
import { CwtCartItemRowComponent } from '../cwt-cart-item-row/cwt-cart-item-row.component';

@Component({
    selector: 'cwt-cart-item-list',
    templateUrl: './cwt-cart-item-list.component.html',
    styleUrls: ['./cwt-cart-item-list.component.scss'],
    imports: [CwtCartItemRowComponent],
})
export class CwtCartItemListComponent implements OnChanges {
  // protected _items: OrderEntry[] = [];
  @Input() items !: cwtOrderEntry[];


  ngOnChanges(): void { }

}


